import React, { useState } from 'react';
import { Info } from 'lucide-react';

const TOOLTIP_TEXT = 'Scored on domain length, TLD tier, keyword strength, memorability, and age. No machine learning is used.';

const ValuationInfo: React.FC<{ className?: string }> = ({ className = '' }) => {
  const [visible, setVisible] = useState(false);

  return (
    <span className={`relative inline-flex items-center ${className}`}>
      <button
        type="button"
        aria-label="Smart Valuation explained"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        onFocus={() => setVisible(true)}
        onBlur={() => setVisible(false)}
        className="ml-1.5 text-gray-400 hover:text-blue-500 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded"
      >
        <Info className="h-4 w-4" strokeWidth={2} />
      </button>
      {visible && (
        <span
          role="tooltip"
          className="absolute left-6 top-0 z-50 w-64 bg-gray-900 text-white text-xs rounded-md px-3 py-2 leading-relaxed pointer-events-none"
        >
          {TOOLTIP_TEXT}
        </span>
      )}
    </span>
  );
};

export default ValuationInfo;
